import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { redirectIfAuthenticated } from '@/app/guards';
import { LandingPage } from '@/features/auth';

function Login() {
  const { redirect } = Route.useSearch();
  return <LandingPage redirectTo={redirect} />;
}

/** Same portal as `/`, but remembers where a signed-out session was heading. */
export const Route = createFileRoute('/(public)/login')({
  validateSearch: z.object({ redirect: z.string().optional() }),
  beforeLoad: redirectIfAuthenticated,
  component: Login,
});
